import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FieldBaseComponent } from '../field-base/field-base.model';

export interface IRadioGroupItem {
    label: string;
    value: string;
    isChecked?: boolean;
    isDefault?: boolean;
}

@Component({
    selector: 'app-input-radio-group',
    template: `
        <div class="radio-group" [formGroup]="parentForm">
            <label class="radio" *ngFor="let radio of group" [ngClass]="cssClasses">
                {{ radio.label }}
                <input type="radio"
                    [formControlName]="controlName"
                    [value]="radio.value"
                    (click)="handleValueChange.emit(radio)" />
                <span class="radio__dot"></span>
            </label>
        </div>
    `,
})
export class RadioGroupComponent extends FieldBaseComponent {
    @Input() group: IRadioGroupItem[];
    @Input() cssClasses: string;
    @Output() handleValueChange = new EventEmitter<IRadioGroupItem>();

    uniqueGroupId: string;

    constructor() {
        super();
    }
}
